import React, { PropsWithChildren } from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { MapPointIcon } from '@cp/ds/src/icons';
import { styled } from '@cp/ds/src/theme';
import { Tokens } from './const';

const AddressBox = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: Tokens.textColor(theme.palette['gray dark']),
}));

type AddressProps = PropsWithChildren<{
  disableInfo?: boolean;
}>;

export const Address = (props: AddressProps) => {
  return (
    <AddressBox
      component="div"
      sx={{
        '.address': {
          filter: props.disableInfo ? 'blur(7px)' : 'none',
          pointerEvents: props.disableInfo ? 'none' : 'all',
        },
      }}
      variant="caption"
    >
      <MapPointIcon fontSize="1.25rem" />
      <span>{props.children}</span>
    </AddressBox>
  );
};
